(function () {
  'use strict';
  if (window.__vvInit) return;
  window.__vvInit = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = !reduce && 'IntersectionObserver' in window;

  /* Only ever hide content once we know we can bring it back. */
  if (canAnimate) root.classList.add('vv-anim');

  function revealAll() {
    var n = document.querySelectorAll('.vv-rv');
    for (var i = 0; i < n.length; i++) n[i].classList.add('is-in');
  }

  function reveal() {
    var items = document.querySelectorAll('.vv-rv');
    if (!items.length) return;
    if (!canAnimate) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        var e = entries[j];
        if (!e.isIntersecting) continue;
        var el = e.target;
        var sibs = el.parentElement
          ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains('vv-rv'); })
          : [el];
        var idx = sibs.indexOf(el);
        el.style.setProperty('--vv-d', (idx > 0 ? Math.min(idx, 8) * 70 : 0) + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    for (var i = 0; i < items.length; i++) io.observe(items[i]);
  }

  function counters() {
    var nodes = document.querySelectorAll('[data-vv-count]');
    if (!nodes.length) return;
    var final = function (n) { n.textContent = n.getAttribute('data-vv-count') + (n.getAttribute('data-vv-suffix') || ''); };
    if (!canAnimate) { Array.prototype.forEach.call(nodes, final); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var n = e.target; io.unobserve(n);
        var target = parseFloat(n.getAttribute('data-vv-count'));
        var suffix = n.getAttribute('data-vv-suffix') || '';
        if (isNaN(target)) { final(n); return; }
        var dur = 900, t0 = null;
        requestAnimationFrame(function tick(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          n.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        });
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  function faq() {
    Array.prototype.forEach.call(document.querySelectorAll('.vv-q'), function (q) {
      var btn = q.querySelector('.vv-q__btn');
      var panel = q.querySelector('.vv-q__a');
      if (!btn || !panel || btn.getAttribute('data-vv-bound')) return;
      btn.setAttribute('data-vv-bound', '1');
      btn.setAttribute('aria-expanded', 'false');
      panel.style.overflow = 'hidden';
      panel.style.height = '0px';
      panel.setAttribute('hidden', '');
      if (!reduce) panel.style.transition = 'height .3s cubic-bezier(.22,.61,.36,1)';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) {
          q.removeAttribute('open');
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.height = '0px';
            setTimeout(function () { panel.setAttribute('hidden', ''); }, reduce ? 0 : 300);
          });
        } else {
          q.setAttribute('open', '');
          panel.removeAttribute('hidden');
          panel.style.height = panel.scrollHeight + 'px';
          setTimeout(function () { panel.style.height = 'auto'; }, reduce ? 0 : 320);
        }
      });
    });
  }

  function magnetic() {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.vv-btn--primary'), function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 6).toFixed(2) + 'px,' + (y * 5 - 2).toFixed(2) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  function init() { reveal(); counters(); faq(); magnetic(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Safety net: nothing may stay invisible, whatever goes wrong above. */
  setTimeout(revealAll, 2500);
  window.addEventListener('load', function () { setTimeout(revealAll, 1200); });
  document.addEventListener('shopify:section:load', init);
})();
